"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const disableItem = toolkitRaw.createAsyncThunk('item/create', async ({ internalItemId }) => {
    try {
        await services_1.default.post(`/api/saas/me/items/${internalItemId}/disable`);
        return true;
    }
    catch (eventError) {
        return false;
    }
});
exports.default = disableItem;
//# sourceMappingURL=index.js.map